// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTranslateOutlinedSvg from "@fishx/icons-svg/es/asn/PTranslateOutlined";
import FishxIcon from '../components/FishxIcon';

var PTranslateOutlined = function PTranslateOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTranslateOutlinedSvg
  }));
};

PTranslateOutlined.displayName = 'PTranslateOutlined';
export default React.forwardRef(PTranslateOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTranslateOutlined.js
// module id = 3689
// module chunks = 0